import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('payment', {
        template: require('./payment-module.html'),
        controller: PaymentModuleCtrl,
        controllerAs: 'vm'
    });

    PaymentModuleCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function PaymentModuleCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.isPassword = false;
        vm.logo = require('Images/nav-logo.png');
        // The header text on top most of the page
        vm.header = 'Login';

        vm.id = $stateParams.id;

        IMP.init('imp59733168'); // 'iamport' 대신 부여받은 "가맹점 식별코드"를 사용

        vm.data = {};

        vm.gateways = [
            // {
            //     val:'kakaopay',
            //     display_name_debug:'간편결제] 카카오페이 - (kakao pay)',
            //     display_name:'간편결제] 카카오페이',
            //     pay_methods: [{
            //         val: 'kpay',
            //         name: 'Kakao Pay'
            //     }]
            // },
            {
                val:'danal_tpay',
                display_name_debug:'다날-신용카드/계좌이체/가상계좌 - (danal)',
                display_name:'다날-신용카드/계좌이체/가상계좌',
                pay_methods: [{
                    val: 'card',
                    name: 'Card'
                }, {
                    val: 'trans',
                    name: 'Bank Transfer'
                }, {
                    val: 'vbank',
                    name: 'Virtual Bank'
                }]
            },
            {
                val:'danal',
                display_name_debug:'다날-휴대폰소액결제 - (danal mobile)',
                display_name:'다날-휴대폰소액결제',
                pay_methods: [{
                    val:'phone',
                    name: 'Phone'
                }]
            }
        ];


        vm.data.gateway = vm.gateways[0];
        //pay!
        vm.pay = function(){


            // vm.data.pg = vm.data.gateway.val;
            vm.data.pg = 'sette';

            console.log(vm.data);


            IMP.request_pay({
                pg : vm.data.pg,
                pay_method : 'vbank',
                merchant_uid : 'merchant_' + new Date().getTime(),
                name : 'Regular Class Payment',
                amount : vm.data.tuition,
                buyer_email: vm.data.student_email,
                buyer_name: vm.data.student_name,
                buyer_tel: vm.data.phone,
                custom_data: {class_id: vm.data.id}
            }, function(rsp) {
                if ( rsp.success ) {
                    var msg = '결제가 완료되었습니다.';
                    msg += '고유ID : ' + rsp.imp_uid;
                    msg += '상점 거래ID : ' + rsp.merchant_uid;
                    msg += '결제 금액 : ' + rsp.paid_amount;
                    msg += '카드 승인번호 : ' + rsp.apply_num;
                } else {
                    var msg = '결제에 실패하였습니다.';
                    msg += '에러내용 : ' + rsp.error_msg;
                }
                alert(msg);
            });

        }

        var request = {
            method: 'GET',
            route: URLS.base + `/regular_class/${vm.id}/locked`,
        };
        QueryService.query(request)
            .then(
                function(response) {
                    vm.data = response.data.data.items[0];
                    console.log(vm.data);
                },
                function(error) {
                    logger.errorFormatResponse(error);
                }
            )
            .finally(function() {
                vm.loading = false;
            });

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/payment-module/payment-module.component.js